import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FilenameTruncateService {
  /**
   * Formats and truncates filename based on max length
   * @param fileName Original filename
   * @param maxLength Maximum length for the name part (excluding extension)
   * @returns Truncated filename with extension preserved
   */
  public truncateFileName(fileName: string, maxLength: number = 20): string {
    if (!fileName) return '';

    const formattedName = fileName.replace(/_/g, ' ');
    const lastDotIndex = formattedName.lastIndexOf('.');

    // No extension
    if (lastDotIndex === -1) {
      return formattedName.length > maxLength ? formattedName.substring(0, maxLength) + '...' : formattedName;
    }

    // Has extension
    const name = formattedName.substring(0, lastDotIndex);
    const extension = formattedName.substring(lastDotIndex);

    if (name.length <= maxLength) {
      return formattedName;
    }

    // Add ellipsis between truncated name and extension, but avoid double-dot
    return `${name.substring(0, maxLength)}..${extension}`;
  }
}
